import React, { useMemo } from 'react';
import DecisionSection from './DecisionSection';
import AIInsightsSection from './AIInsightsSection';
import { extractSectionSummaries } from '../../utils/extractSectionSummaries';
import { parseLogicData } from '../../utils/parseComparisonData';

const DecisionRenderer = ({ 
  decision, 
  mode = 'user',
  validationErrors = null,
  onErrorClick = null,
  showErrorBubbles = false,
  dataPromptHelper = null,
  getErrorIndicatorsFn = null
}) => {
  if (!decision) return null;

  const sectionSummaries = useMemo(() => 
    extractSectionSummaries(decision.ai_recommendation || ''),
    [decision.ai_recommendation]
  );

  // Parse Logic FIRST to get option names for Universe and Vibe
  const logicParsed = useMemo(() => 
    parseLogicData(decision.logic_pros || [], decision.logic_cons || []),
    [decision.logic_pros, decision.logic_cons]
  );

  const getErrorIndicators = getErrorIndicatorsFn || (() => null);

  return (
    <div className="decision-content">
      <DecisionSection
        sectionType="logic"
        decision={decision}
        sectionSummary={sectionSummaries.logic}
        errorIndicators={getErrorIndicators('logic')}
      />

      <DecisionSection
        sectionType="universe"
        decision={decision}
        sectionSummary={sectionSummaries.universe}
        errorIndicators={getErrorIndicators('universe')}
        optionAName={logicParsed.optionA.name}
        optionBName={logicParsed.optionB.name}
      />

      <DecisionSection
        sectionType="vibe"
        decision={decision}
        sectionSummary={sectionSummaries.vibe}
        errorIndicators={getErrorIndicators('vibe')}
        optionAName={logicParsed.optionA.name}
        optionBName={logicParsed.optionB.name}
      />

      {dataPromptHelper}

      <AIInsightsSection
        synthesis={sectionSummaries.synthesis}
        errorIndicators={getErrorIndicators('synthesis')}
      />
    </div>
  );
};

export default DecisionRenderer;
